import { useContext, useState } from "react";
import Select, { components } from "react-select";

import DatePicker from "react-date-picker";
import appStyles from "../../../App.module.css";
import appConstants, { addDays, formatDate, totalDaysInCurrentYear } from "../../../app-constants";
import { BusinessTravelContext } from "../../BusinessTravel";
import { colourStyles, noOfEmployee } from "../../config/bt-constants";
import { IBusinessTravelContext, ISelectOption } from "../../config/interfaces";
import Popup from "../Popup";
import SearchIcon from "../icons/SearchIcon";
import LoadingModal from "../modal/LoadingModal";
import EditCurrencyAndCompany from "./EditCurrencyAndCompany";

const YourQuote = () => {
  const { quoteData, version } = useContext(BusinessTravelContext) as IBusinessTravelContext;
  const [isDateEditable, setIsDateEditable] = useState<boolean>(false);
  const [isNumberOfTripsEditable, setIsNumberOfTripsEditable] = useState<boolean>(false);
  const [isNumberOfEmployeeEditable, setIsNumberOfEmployeeEditable] = useState<boolean>(false);

  const [isHostCountryEditable, setIsHostCountryEditable] = useState<boolean>(false);
  return (
    <div>
      <h3 className={appStyles.btTitle}>Your quote</h3>

      <div className={`${appStyles.btQuoteHeaderDetail}`}>
        <div>
          <p className={appStyles.btSubTitle}>Policy term</p>
          <div className={`${appStyles.tripSummaryValue} ${appStyles.btTripSummaryValue}`}>
            {formatDate(new Date(quoteData.start_date))} - {formatDate(new Date(quoteData.end_date))}
          </div>
        </div>
        <span className={appStyles.btQuoteLink} onClick={() => setIsDateEditable(true)}>
          Edit
        </span>
      </div>

      {isDateEditable && (
        <Popup
          onClose={() => {
            setIsDateEditable(false);
          }}
          styleDatePicker={true}
          title="Policy Term"
          showTitle={false}
          children={<EditPolicyTerm setIsDateEditable={setIsDateEditable} />}
        />
      )}

      <div className={`${appStyles.btQuoteHeaderDetail}`}>
        <div>
          <p className={appStyles.btSubTitle}>Number of trips</p>
          <div className={`${appStyles.tripSummaryValue} ${appStyles.btTripSummaryValue}`}>
            {quoteData.noOfTrips?.from}-{quoteData.noOfTrips?.till}
          </div>
        </div>
        <span className={appStyles.btQuoteLink} onClick={() => setIsNumberOfTripsEditable(true)}>
          Edit
        </span>
      </div>
      {isNumberOfTripsEditable && (
        <Popup
          onClose={() => {
            setIsNumberOfTripsEditable(false);
          }}
          showTitle={false}
          title="Number of Trips"
          children={<EditNumberTrips setIsNumberOfTripsEditable={setIsNumberOfTripsEditable} />}
        />
      )}

      <div className={`${appStyles.btQuoteHeaderDetail}`}>
        <div>
          <p className={appStyles.btSubTitle}>Company size</p>
          <div className={`${appStyles.tripSummaryValue} ${appStyles.btTripSummaryValue}`}>
            {quoteData.noOfEmployee} employees
          </div>
        </div>
        <span className={appStyles.btQuoteLink} onClick={() => setIsNumberOfEmployeeEditable(true)}>
          Edit
        </span>
      </div>
      {isNumberOfEmployeeEditable && (
        <Popup
          onClose={() => {
            setIsNumberOfEmployeeEditable(false);
          }}
          title="Company size"
          showTitle={false}
          children={
            <EditCurrencyAndCompany
              itemsArray={noOfEmployee}
              closeModel={setIsNumberOfEmployeeEditable}
              type={"noOfEmployee"}
            />
          }
        />
      )}

      {version === "EU" && (
        <div className={`${appStyles.btQuoteHeaderDetail}`}>
          <div>
            <p className={appStyles.btSubTitle}>Company location</p>
            <div className={`${appStyles.tripSummaryValue} ${appStyles.btTripSummaryValue}`}>
              {quoteData?.host_country?.name}
            </div>
          </div>
          <span className={appStyles.btQuoteLink} onClick={() => setIsHostCountryEditable(true)}>
            Edit
          </span>
        </div>
      )}

      {isHostCountryEditable && (
        <Popup
          onClose={() => {
            setIsHostCountryEditable(false);
          }}
          title="Company location"
          showTitle={false}
          children={<EditDestinationCountries setIsHostCountryEditable={setIsHostCountryEditable} />}
        />
      )}

      <hr className={appStyles.btHrStyle} />
    </div>
  );
};

export default YourQuote;

type EditPolicyTermProps = {
  setIsDateEditable: React.Dispatch<React.SetStateAction<boolean>>;
};

const EditPolicyTerm = (Props: EditPolicyTermProps) => {
  const { setIsDateEditable } = Props;
  const { quoteData, setQuoteData, setQuoteResult, setLoader, loader, createQuote } = useContext(
    BusinessTravelContext
  ) as IBusinessTravelContext;
  const [datePickerInitialValue, setDatePickerInitialValue] = useState(quoteData.start_date);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`${appStyles.formRow}`}>
      <div className={appStyles.formBlock}>
        <div className={appStyles.formField}>
          <label className={` ${appStyles.btSubTitle}`}>Start date</label>
          <DatePicker
            calendarClassName={`${appStyles.bfpDatePickerCalendar} ${appStyles.btDatePickerCalendar}`}
            className={`${appStyles.bfpDatePicker} ${appStyles.btDatePicker} ${appStyles.bfpDatePickerCalendarStartDate} ${appStyles.btDatePickerCalendarStartDate}`}
            dayPlaceholder="dd"
            monthPlaceholder="mm"
            yearPlaceholder="yyyy"
            format={appConstants.datePickerFormat}
            value={datePickerInitialValue}
            maxDate={addDays(new Date(), 55)}
            id="start_date"
            onClick={() => setIsOpen(true)}
            onCalendarClose={() => setIsOpen(false)}
            isOpen={isOpen}
            onChange={(value: any) => {
              setDatePickerInitialValue(value);
            }}
            minDate={new Date()}
          />

          <div className={`${appStyles.btQuoteBtnWrap}`}>
            <button className={`${appStyles.btQuoteBtnOutline}`} onClick={() => setIsDateEditable(false)}>
              Cancel
            </button>
            <button
              className={`${appStyles.btQuoteBtn}`}
              onClick={async () => {
                try {
                  setLoader("date");
                  let _quoteData = {
                    ...quoteData,
                    start_date: datePickerInitialValue,
                    end_date: addDays(datePickerInitialValue, totalDaysInCurrentYear(datePickerInitialValue)),
                  };
                  setIsDateEditable(false);

                  const createQuoteResponse = await createQuote(_quoteData);
                  setQuoteResult(createQuoteResponse);
                  setQuoteData(_quoteData);
                } catch (e: any) {
                  console.log(e.message);
                } finally {
                  setLoader(null);
                }
              }}
            >
              Save
              {loader && (
                <Popup
                  onClose={() => {}}
                  title=""
                  children={<LoadingModal />}
                  closeButton={false}
                  LoadingModal={true}
                />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

type EditNumberTripsProps = {
  setIsNumberOfTripsEditable: React.Dispatch<React.SetStateAction<boolean>>;
};

const EditNumberTrips = (Props: EditNumberTripsProps) => {
  const { setIsNumberOfTripsEditable } = Props;
  const { quoteData, loader, setLoader, createQuote, setQuoteResult, setQuoteData, tripsData } = useContext(
    BusinessTravelContext
  ) as IBusinessTravelContext;

  const [initialValue, setInitialValue] = useState<any>(quoteData.noOfTrips);

  return (
    <div className={appStyles.formRow}>
      <div className={appStyles.formBlock}>
        <label className={` ${appStyles.btSubTitle}`}>Number of covered trips</label>

        <div className={`${appStyles.formField}`}>
          <Select
            name={"noOfTrips"}
            id={"noOfTrips"}
            menuPosition="fixed"
            styles={colourStyles}
            options={tripsData?.numberOfTrips.filter((_tripsData: any) => _tripsData?.id !== -1)}
            value={initialValue}
            onChange={(newValue: ISelectOption | null) => {
              setInitialValue(newValue);
            }}
            getOptionValue={(option: any) => option}
            getOptionLabel={(option: any) => `${option?.from}-${option?.till}`}
            isOptionDisabled={(option: any) => option.disabled}
            className={appStyles.btSelect}
            classNamePrefix="btSelect"
            maxMenuHeight={400}
          />
        </div>
        <p className={`${appStyles.btNoteWrap}`}>
          Trips are counted on a per person, per trip basis ie. 3 employees on one trip counts as 3 trips.
        </p>

        <div className={`${appStyles.btQuoteBtnWrap}`}>
          <button className={`${appStyles.btQuoteBtnOutline}`} onClick={() => setIsNumberOfTripsEditable(false)}>
            Cancel
          </button>
          <button
            className={`${appStyles.btQuoteBtn}`}
            onClick={async () => {
              try {
                setLoader("trip");

                const _quoteData = {
                  ...quoteData,
                  noOfTrips: initialValue,
                };
                setIsNumberOfTripsEditable(false);

                const createQuoteResponse = await createQuote(_quoteData);
                setQuoteResult(createQuoteResponse);
                setQuoteData(_quoteData);
              } catch (error) {
                console.log(error);
              } finally {
                setLoader(null);
              }
            }}
            type="button"
          >
            Save
            {loader && (
              <Popup onClose={() => {}} title="" children={<LoadingModal />} closeButton={false} LoadingModal={true} />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

type EditDestinationCountriesProps = {
  setIsHostCountryEditable: React.Dispatch<React.SetStateAction<boolean>>;
};

const EditDestinationCountries = (Props: EditDestinationCountriesProps) => {
  const { setIsHostCountryEditable } = Props;
  const { quoteData, setQuoteData, setQuoteResult, setLoader, loader, createQuote, tripsData } = useContext(
    BusinessTravelContext
  ) as IBusinessTravelContext;
  const [initialValue, setInitialValue] = useState<any>(quoteData?.host_country);

  const style = { paddingLeft: "12px", lineHeight: 0 };
  const Control = ({ children, ...props }: any) => (
    <components.Control {...props}>
      <span style={style}>
        <SearchIcon />
      </span>
      {children}
    </components.Control>
  );

  return (
    <>
      <div className={appStyles.formRow}>
        <div className={appStyles.formBlock}>
          <label className={` ${appStyles.btSubTitle}`}>Company location</label>

          <div className={`${appStyles.formField}`}>
            <Select
              components={{
                Control,
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
              }}
              styles={colourStyles}
              isSearchable={true}
              menuPosition="fixed"
              name="host_country"
              id="host_country"
              value={initialValue}
              placeholder={<div style={{ color: "#A8A8A8" }}>Search countries</div>}
              options={tripsData?.hostCountries}
              isLoading={tripsData?.hostCountries ? false : true}
              onChange={(newValue: any | null) => {
                setInitialValue(newValue);
              }}
              getOptionValue={(option: any) => `${option?.code}`}
              getOptionLabel={(option: any) => `${option?.name}`}
              className={`${appStyles.btSelect} ${appStyles.btSearchSelect}`}
              classNamePrefix="btSelect"
              blurInputOnSelect={false}
            />

            <div className={`${appStyles.btQuoteBtnWrap}`}>
              <button className={`${appStyles.btQuoteBtnOutline}`} onClick={() => setIsHostCountryEditable(false)}>
                Cancel
              </button>
              <button
                className={`${appStyles.btQuoteBtn}`}
                onClick={async () => {
                  try {
                    setLoader("trip");
                    const _quoteData = {
                      ...quoteData,
                      host_country: initialValue,
                    };
                    setIsHostCountryEditable(false);
                    const createQuoteResponse = await createQuote(_quoteData);
                    setQuoteResult(createQuoteResponse);
                    setQuoteData(_quoteData);
                  } catch (error) {
                    console.log(error);
                  } finally {
                    setLoader(null);
                  }
                }}
                type="button"
              >
                Save
                {loader && (
                  <Popup
                    onClose={() => {}}
                    title=""
                    children={<LoadingModal />}
                    closeButton={false}
                    LoadingModal={true}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
